<template>
  <b-navbar toggleable="lg" type="dark" variant="primary" fixed="top">
    <b-navbar-brand :to="{name: 'welcome'}">Digital Display</b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item :to="{name: 'welcome'}">Overview</b-nav-item>
        <b-nav-item :to="{name: 'users'}" v-if="permission('users')">Users</b-nav-item>
        <b-nav-item :to="{name: 'media'}" v-if="permission('media')">Media Library</b-nav-item>
        <b-nav-item :to="{name: 'playlists'}" v-if="permission('playlist-view') || permission('publish')">Playlists</b-nav-item>
        <b-nav-item :to="{name: 'loopPlaylists'}" v-if="permission('playlist-view') || permission('publish')">Looped Playlists</b-nav-item>
        <b-nav-item :to="{name: 'weeklyPlaylists'}" v-if="permission('playlist-view') || permission('publish')">Weekly Playlists</b-nav-item>
        <b-nav-item :to="{name: 'devices'}" v-if="permission('devices')">Devices</b-nav-item>
        <b-nav-item :to="{name: 'groups'}" v-if="permission('devices')">Groups</b-nav-item>
        <b-nav-item :to="{name: 'logs'}" v-if="permission('logs')">Logs</b-nav-item>

        <!-- <b-nav-item-dropdown v-if="userRole === 1">
            <template slot="button-content">Users</template>
            <b-dropdown-item :to="{name: 'users'}" >Users list</b-dropdown-item>
        </b-nav-item-dropdown> -->
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right>
          <!-- Using 'button-content' slot -->
          <template slot="button-content">{{ userData.name }}</template>
          <b-dropdown-item @click="logout">Sign Out</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapState } from 'vuex';
import rolesMixin from '@/modules/rolesMixin';

export default {
  mixins: [rolesMixin],
  methods:
  {
    logout() {
      this.$store.dispatch('AuthStore/logout').then(
        () => {
          this.$router.push({ name: 'login' });
        },
      );
    },
  },
  computed: {
    ...mapState('AuthStore', ['userData']),
  },
};
</script>
